
<app-form (submit)="submit()">
  <div class="layout">
    @if (submitting) {
      <div style="text-align:center;">
        Saving your username...
        <app-spinner></app-spinner>
      </div>
    }
    @if (!submitting) {
      @if (user.username) {
        Looks like your username is already set! It is:
        <h1>&#64;{{user.username}}</h1>
        If you need to change it we may be able to help. Please contact TYT Support
        at support&#64;tytnetwork.com.
        <div class="actions">
          <button mat-raised-button color="primary" (click)="usernameSet.next()">OK</button>
        </div>
      }
      @if (!user.username) {
        <p>
          Before you can set up your profile or access TYT's social features, you need to choose a username.
          Choose carefully! Once you've set your username, it cannot be changed.
        </p>
        @if (usernameError) {
          <div class="alert alert-danger">
            {{usernameError}}
          </div>
        }
        <mat-form-field appearance="outline">
          <mat-label>Username</mat-label>
          <input
            matInput
            [(ngModel)]="username"
            pattern="[a-z][a-z0-9]+"
            autocomplete="off"
            type="text"
            name="newUsername"
            (change)="checkIfUsernameAvailable()"
            (keydown)="checkIfUsernameAvailable()"
            />
            <mat-hint>Can only contain lowercase letters, numbers, and underscores</mat-hint>
          </mat-form-field>
          @if (showUsernameMessage) {
            @if (!isValidUsername(username)) {
              <div class="alert alert-danger">
                <mat-icon>close</mat-icon>
                Username must start with a lowercase letter and include only lowercase letters,
                numbers and underscores.
              </div>
            }
            @if (isValidUsername(username)) {
              <div class="alert"
                [class.alert-info]="checkingIfUsernameAvailable"
                [class.alert-danger]="!checkingIfUsernameAvailable && usernameAvailable === false"
                [class.alert-success]="!checkingIfUsernameAvailable && usernameAvailable === true"
                >
                @if (checkingIfUsernameAvailable) {
                  <app-spinner class="line inline"></app-spinner>
                  Checking if username is available...
                }
                @if (!checkingIfUsernameAvailable) {
                  @if (usernameAvailable === false) {
                    <mat-icon>close</mat-icon>
                    Username not available
                  }
                  @if (usernameAvailable === true) {
                    <mat-icon>done</mat-icon>
                    Username &#64;{{username}} is available!
                  }
                }
              </div>
            }
          }
          <div class="actions">
            <button [disabled]="!canSubmit() || !usernameAvailable" mat-raised-button color="primary">Save Username</button>
            <a mat-button (click)="canceled.next()">Cancel</a>
          </div>
        }
      }
    </div>
  </app-form>